export default __webpack_public_path__ + "static/media/stampita-vamos-buenos-aires.9236c05b.svg";